/* APH PDP loyalty points (C2)
   Points = floor(GBP payable total of the ACTIVE bulk tier). 1 GBP = 1 point.
   Follows [data-bulk-tier].active via the theme's bubbling bulk-tier-change
   event (detail.lineGbp). GBP base values only - currency selector ignored.
   Digit-reel odometer on tab change, no hard cut. Re-init safe: Dawn
   product-info re-renders the section on variant change, so init() is
   idempotent and a MutationObserver rebinds fresh nodes. */
(function () {
  'use strict';

  function floorPoints(gbp) {
    var n = parseFloat(gbp);
    if (!isFinite(n) || n < 0) return 0;
    return Math.floor(n + 1e-6);
  }

  /* --- digit reel ----------------------------------------------------- */
  function h(el) {
    var fs = parseFloat(getComputedStyle(el).fontSize) || 14;
    return Math.round(fs * 1.25 * 100) / 100;
  }

  function buildStrip(el, hPx) {
    var strip = document.createElement('span');
    strip.className = 'aph-loyalty-od__strip';
    for (var i = 0; i <= 9; i++) {
      var s = document.createElement('span');
      s.textContent = String(i);
      s.style.height = hPx + 'px';
      s.style.lineHeight = hPx + 'px';
      strip.appendChild(s);
    }
    return strip;
  }

  function render(el, value) {
    var chars = String(Math.max(0, Math.round(value))).split('');
    var hPx = h(el);
    if (!el._loyRoot) {
      el.textContent = '';
      el._loyRoot = document.createElement('span');
      el._loyRoot.style.display = 'inline-flex';
      el._loyRoot.style.alignItems = 'center';
      el.appendChild(el._loyRoot);
    }
    var root = el._loyRoot;
    while (root.childNodes.length > chars.length) root.removeChild(root.lastChild);
    chars.forEach(function (ch, i) {
      var col = root.childNodes[i];
      if (!col) {
        col = document.createElement('span');
        col.style.display = 'inline-block';
        col.style.overflow = 'hidden';
        root.appendChild(col);
      }
      col.style.height = hPx + 'px';
      col.style.width = '0.62em';
      col.style.textAlign = 'center';
      if (!col.firstChild || col.firstChild.className !== 'aph-loyalty-od__strip') {
        col.textContent = '';
        col.appendChild(buildStrip(el, hPx));
      }
      var strip = col.firstChild;
      var spans = strip.children;
      for (var k = 0; k < spans.length; k++) {
        spans[k].style.height = hPx + 'px';
        spans[k].style.lineHeight = hPx + 'px';
      }
      strip.style.transform = 'translateY(' + -parseInt(ch, 10) * hPx + 'px)';
    });
  }

  function animateTo(el, to, duration) {
    to = Math.max(0, Math.round(to));
    if (el._loyRaf) (el._loyCancel || cancelAnimationFrame)(el._loyRaf);
    var from = el._loyValue != null ? el._loyValue : to;
    if (from === to || duration === 0) {
      el._loyValue = to;
      render(el, to);
      return;
    }
    var raf =
      window.requestAnimationFrame ||
      function (cb) {
        return setTimeout(function () {
          cb(performance.now());
        }, 16);
      };
    var start = performance.now();
    function frame(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var v = from + (to - from) * eased;
      el._loyValue = v;
      render(el, v);
      if (t < 1) el._loyRaf = raf(frame);
      else {
        el._loyValue = to;
        render(el, to);
        el._loyRaf = null;
      }
    }
    el._loyRaf = raf(frame);
    el._loyCancel = window.cancelAnimationFrame || clearTimeout;
  }

  /* --- points source --------------------------------------------------- */
  function sectionOf(el) {
    return el.closest('.shopify-section') || document;
  }

  function currentPoints(loyaltyEl) {
    var sec = sectionOf(loyaltyEl);
    var tier = sec.querySelector('[data-bulk-tier].active, .bulk-tier.active');
    if (tier) {
      var tp = tier.querySelector('.tier-price[data-gbp]');
      if (tp) return floorPoints(tp.getAttribute('data-gbp'));
    }
    var priceEl = sec.querySelector(
      '.price-row .price .cur-price[data-gbp], .price-row .cur-price[data-gbp], .featured-copy .cur-price[data-gbp]'
    );
    if (priceEl) {
      var unit = parseFloat(priceEl.getAttribute('data-unit-gbp') || priceEl.getAttribute('data-gbp'));
      var form = sec.querySelector('form.aph-product-form, form[data-type="add-to-cart-form"]');
      var qtyInput = form && form.querySelector('input[name="quantity"], [data-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (isFinite(unit)) return floorPoints(unit * qty);
    }
    /* last resort: keep the server-rendered number */
    var ptsEl = loyaltyEl.querySelector('[data-aph-loyalty-points]');
    return parseInt((ptsEl && ptsEl.textContent) || '0', 10) || 0;
  }

  /* --- gallery dedupe (C2 2026-09-14) ----------------------------------
     appendStoryImagesToGallery (aph-theme-ui.js) dedupes story images by
     exact filename, but product media created from a Files source gets a
     `_<uuid>` suffix on copy, so story 3D images that are ALSO real product
     media were appended twice (5 slides). Normalize the suffix and drop
     later duplicates in main + thumbs rails. Runs post-append. */
  function normImgName(src) {
    var n = (src || '').split('?')[0].split('/').pop() || '';
    return n.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.)/i, '');
  }

  function dedupeRail(wrap) {
    if (!wrap) return 0;
    var seen = {};
    var removed = 0;
    Array.prototype.slice.call(wrap.children).forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      var key = normImgName(img.getAttribute('src') || img.currentSrc || '');
      if (!key) return;
      if (seen[key]) {
        slide.parentNode.removeChild(slide);
        removed++;
      } else {
        seen[key] = true;
      }
    });
    return removed;
  }

  function dedupeGalleries() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (mainEl) {
      var wrap = mainEl.querySelector('.swiper-wrapper');
      var mediaRoot = mainEl.closest('.featured-media') || mainEl.parentElement;
      var thumbsEl = mediaRoot ? mediaRoot.querySelector('[data-pdp-thumbs]') : null;
      var n = dedupeRail(wrap) + dedupeRail(thumbsEl ? thumbsEl.querySelector('.swiper-wrapper') : null);
      if (n > 0) {
        if (mainEl.swiper && mainEl.swiper.update) mainEl.swiper.update();
        if (thumbsEl && thumbsEl.swiper && thumbsEl.swiper.update) thumbsEl.swiper.update();
      }
    });
  }

  /* --- gallery slide removal (C 2026-09-16, fadogia only) ----------------
     Harry: benefits + test-booster tiles belong on the lower story sections,
     not in the gallery rail. Media stays attached (deleting media deletes the
     underlying Files asset - learned the hard way on ibutamoren), so strip
     matching slides from main + thumbs rails and collapse the rail when only
     the product shot remains. */
  var GALLERY_REMOVE = /\/products\/fadogia(?:[?#/]|$)/.test(location.pathname + location.search)
    ? [/aph-fadogia-benefits/i, /aph-fadogia-test-booster/i]
    : null;

  function removeRailSlides(wrap) {
    if (!wrap || !GALLERY_REMOVE) return false;
    var removed = false;
    Array.prototype.slice.call(wrap.children).forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      var src = (img.getAttribute('src') || '') + ' ' + (img.currentSrc || '') + ' ' +
        (img.getAttribute('data-src') || '') + ' ' + (img.getAttribute('srcset') || '');
      for (var i = 0; i < GALLERY_REMOVE.length; i++) {
        if (GALLERY_REMOVE[i].test(src)) {
          slide.parentNode.removeChild(slide);
          removed = true;
          break;
        }
      }
    });
    return removed;
  }

  function pruneGalleries() {
    if (!GALLERY_REMOVE) return;
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (mainEl) {
      var wrap = mainEl.querySelector('.swiper-wrapper');
      var mediaRoot = mainEl.closest('.featured-media') || mainEl.parentElement;
      var thumbsEl = mediaRoot ? mediaRoot.querySelector('[data-pdp-thumbs]') : null;
      var moved = removeRailSlides(wrap) | removeRailSlides(thumbsEl ? thumbsEl.querySelector('.swiper-wrapper') : null);
      if (thumbsEl && thumbsEl.querySelectorAll('.swiper-slide').length <= 1) {
        thumbsEl.style.display = 'none';
        moved = true;
      }
      if (moved) {
        if (mainEl.swiper && mainEl.swiper.update) mainEl.swiper.update();
        if (thumbsEl && thumbsEl.swiper && thumbsEl.swiper.update) thumbsEl.swiper.update();
      }
    });
  }

  /* --- gallery tail order (C 2026-09-16, ibutamoren only) ----------------
     Harry: product shots first, SARM Academy stats bars second-to-last, COA
     very last. Story tiles are JS-appended after media by theme-ui, so media
     order alone cannot put stats/COA at the tail. Move matching slides to the
     end of main + thumbs rails, scoped to the ibutamoren PDP only. */
  var GALLERY_TAIL = /\/products\/ibutamoren(?:-20mg)?(?:[?#/]|$)/.test(location.pathname + location.search)
    ? [/IbutamorenScale\.jpg/i, /COA-MK677/i]
    : null;

  function reorderRail(wrap) {
    if (!wrap || !GALLERY_TAIL) return false;
    var moved = false;
    GALLERY_TAIL.forEach(function (re) {
      Array.prototype.slice.call(wrap.children).forEach(function (slide) {
        var img = slide.querySelector('img');
        if (!img) return;
        var src = (img.getAttribute('src') || '') + ' ' + (img.currentSrc || '') + ' ' +
          (img.getAttribute('data-src') || '') + ' ' + (img.getAttribute('srcset') || '');
        if (re.test(src)) {
          wrap.appendChild(slide);
          moved = true;
        }
      });
    });
    return moved;
  }

  function reorderGalleries() {
    if (!GALLERY_TAIL) return;
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (mainEl) {
      var wrap = mainEl.querySelector('.swiper-wrapper');
      var mediaRoot = mainEl.closest('.featured-media') || mainEl.parentElement;
      var thumbsEl = mediaRoot ? mediaRoot.querySelector('[data-pdp-thumbs]') : null;
      var moved = reorderRail(wrap) | reorderRail(thumbsEl ? thumbsEl.querySelector('.swiper-wrapper') : null);
      if (moved) {
        if (mainEl.swiper && mainEl.swiper.update) mainEl.swiper.update();
        if (thumbsEl && thumbsEl.swiper && thumbsEl.swiper.update) thumbsEl.swiper.update();
      }
    });
  }

  /* --- init ------------------------------------------------------------ */
  function initEl(el) {
    var ptsEl = el.querySelector('[data-aph-loyalty-points]');
    if (!ptsEl) return;
    el.dataset.loyaltyBound = '1';
    /* Seed without spin from the live DOM state */
    ptsEl._loyValue = null;
    animateTo(ptsEl, currentPoints(el), 0);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-aph-loyalty]').forEach(function (el) {
      if (!el.dataset.loyaltyBound) initEl(el);
    });
    dedupeGalleries();
    reorderGalleries();
    pruneGalleries();
  }

  /* Tier clicks: theme applyTierPrice dispatches this (bubbles) with the
     GBP line total - one delegated listener survives section re-renders. */
  document.addEventListener('bulk-tier-change', function (e) {
    var sec = (e.target && e.target.closest && e.target.closest('.shopify-section')) || document;
    var gbp = e.detail && e.detail.lineGbp;
    if (gbp == null) return;
    sec.querySelectorAll('[data-aph-loyalty]').forEach(function (el) {
      var ptsEl = el.querySelector('[data-aph-loyalty-points]');
      if (ptsEl) animateTo(ptsEl, floorPoints(gbp), 480);
    });
  });

  /* Qty stepper edits (not via a tier) */
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches('input[name="quantity"], [data-qty-input]')) return;
    var sec = e.target.closest('.shopify-section') || document;
    sec.querySelectorAll('[data-aph-loyalty]').forEach(function (el) {
      var ptsEl = el.querySelector('[data-aph-loyalty-points]');
      if (ptsEl) animateTo(ptsEl, currentPoints(el), 480);
    });
  });

  /* Dawn product-info re-renders the section on variant change: rebind */
  var rebindT = null;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && (n.matches('[data-aph-loyalty]') || n.querySelector('[data-aph-loyalty]'))) {
          clearTimeout(rebindT);
          rebindT = setTimeout(function () {
            init(document);
          }, 60);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  /* theme-ui appends story slides on its own init - sweep again after it */
  window.addEventListener('load', function () {
    setTimeout(function () { dedupeGalleries(); reorderGalleries(); pruneGalleries(); }, 250);
    setTimeout(function () { dedupeGalleries(); reorderGalleries(); pruneGalleries(); }, 900);
    setTimeout(function () { dedupeGalleries(); reorderGalleries(); pruneGalleries(); }, 2000);
  });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
